import {
	AUTH_REQUEST,
	AUTH_AUTHENTICATE,
	AUTH_REGISTER,
	AUTH_SUCCESS,
	AUTH_ERROR,
	AUTH_LOGOUT,
	AUTH_REFRESH,
	AUTH_AUTHENTICATE_LINKEDIN,
	AUTH_AUTHENTICATE_GOOGLE,
	AUTH_VERIFY_EMAIL,
	AUTH_REQUEST_PASSWORD_CHANGE,
	AUTH_CHANGE_PASSWORD,
	USER_UPGRADE,
	USER_CARD_INFO,
	USER_SUCCESS,
	USER_ERROR,
} from '../types';

import axios from '../axios';

import _ from 'lodash';

const initToken = localStorage.getItem('token') || '';

if (initToken) {
	axios.defaults.headers.common['Authorization'] = initToken;
}

const state = {
	currentUser: null,
	isLoading: false,
	error: null,
	token: initToken,
	card: null
};

const getters = {
	getCurrentUser: (state) => state.currentUser,
	isAuthLoading: (state) => state.isLoading,
	getToken: (state) => state.token,
	getCardInfo: (state) => state.card
};

const actions = {
	[AUTH_AUTHENTICATE]: ({ commit }, { email, password, rememberMe }) => {
		return new Promise((resolve, reject) => {
			commit(AUTH_REQUEST);
			axios
				.post('/api/v1/users/authenticate', { email, password, rememberMe })
				.then((resp) => {
					const { token, user } = resp.data;
					localStorage.setItem('token', token);
					axios.defaults.headers.common['Authorization'] = token;

					commit(AUTH_SUCCESS, { token, user });
					resolve(resp);
				})
				.catch((err) => {
					localStorage.removeItem('token');
					commit(AUTH_ERROR, err);
					reject(err);
				});
		});
	},
	[AUTH_AUTHENTICATE_LINKEDIN]: ({ commit }, { code }) => {
		return new Promise((resolve, reject) => {
			commit(AUTH_REQUEST);
			axios
				.post('/api/v1/users/authenticate_linkedin/', { code })
				.then((resp) => {
					commit(AUTH_SUCCESS, { profile: resp.data });
					resolve(resp);
				})
				.catch((err) => {
					commit(AUTH_ERROR, err);
					reject(err);
				});
		});
	},
	[AUTH_AUTHENTICATE_GOOGLE]: ({ commit }, { code }) => {
		return new Promise((resolve, reject) => {
			commit(AUTH_REQUEST);
			axios
				.post('/api/v1/users/authenticate_google/', { code })
				.then((resp) => {
					commit(AUTH_SUCCESS, { profile: resp.data });
					resolve(resp);
				})
				.catch((err) => {
					commit(AUTH_ERROR, err);
					reject(err);
				});
		});
	},
	[AUTH_REGISTER]: ({ commit }, { email, password }) => {
		return new Promise((resolve, reject) => {
			commit(AUTH_REQUEST);
			axios
				.post('/api/v1/users/', { email, password })
				.then((resp) => {
					const { token, user } = resp.data;
					localStorage.setItem('token', token);
					axios.defaults.headers.common['Authorization'] = token;

					commit(AUTH_SUCCESS, { token, user });
					resolve(resp);
				})
				.catch((err) => {
					commit(AUTH_ERROR, err);
					reject(err);
				});
		});
	},
	[USER_UPGRADE]: ({ commit }, { token, plan }) => {
		return new Promise((resolve, reject) => {
			commit(AUTH_REQUEST);
			axios
				.post('/api/v1/users/upgrade/', { token, plan })
				.then((resp) => {
					commit(USER_SUCCESS, { user: resp.data.user });
					resolve(resp);
				})
				.catch((err) => {
					commit(USER_ERROR, err);
					reject(err);
				});
		});
	},
	[AUTH_REFRESH]: ({ commit }) => {
		return new Promise((resolve, reject) => {
			commit(AUTH_REQUEST);
			axios
				.get('/api/v1/users/me')
				.then((resp) => {
					commit(AUTH_SUCCESS, { user: resp.data });
					resolve(resp);
				})
				.catch((err) => {
					localStorage.removeItem('token');
					delete axios.defaults.headers.common['Authorization'];

					commit(AUTH_ERROR, err);
					reject(err);
				});
		});
	},
	[AUTH_LOGOUT]: ({ commit }) => {
		return new Promise((resolve, reject) => {
			commit(AUTH_LOGOUT);
			localStorage.removeItem('token');
			delete axios.defaults.headers.common['Authorization'];
			resolve();
		});
	},
	[AUTH_VERIFY_EMAIL]: ({ commit }, token) => {
		return new Promise((resolve, reject) => {
			commit(AUTH_REQUEST);
			axios
				.post('/api/v1/users/verify_email/', { token })
				.then((resp) => {
					const { token, user } = resp.data;
					localStorage.setItem('token', token);
					axios.defaults.headers.common['Authorization'] = token;

					commit(AUTH_SUCCESS, { token, user });
					resolve(resp);
				})
				.catch((err) => {
					localStorage.removeItem('token');
					commit(AUTH_ERROR, err);
					reject(err);
				});
		});
	},
	[AUTH_REQUEST_PASSWORD_CHANGE]: ({ commit }, email) => {
		return new Promise((resolve, reject) => {
			commit(AUTH_REQUEST);
			axios
				.post('/api/v1/users/request_password_change/', { email })
				.then((resp) => {
					commit(AUTH_SUCCESS, {});
					resolve(resp);
				})
				.catch((err) => {
					commit(AUTH_ERROR, err);
					reject(err);
				});
		});
	},
	[AUTH_CHANGE_PASSWORD]: ({ commit }, { token, password }) => {
		return new Promise((resolve, reject) => {
			commit(AUTH_REQUEST);
			axios
				.post('/api/v1/users/change_password/', { token, password })
				.then((resp) => {
					const { token, user } = resp.data;
					localStorage.setItem('token', token);
					axios.defaults.headers.common['Authorization'] = token;

					commit(AUTH_SUCCESS, { token, user });
					resolve(resp);
				})
				.catch((err) => {
					localStorage.removeItem('token');
					commit(AUTH_ERROR, err);
					reject(err);
				});
		});
	},
	[USER_CARD_INFO]: ({ commit }) => {
		return new Promise((resolve, reject) => {
			commit(AUTH_REQUEST);
			axios
				.get('/api/v1/users/card_info/')
				.then((resp) => {
					const { card } = resp.data;
					commit(USER_SUCCESS, { card });
					resolve(resp);
				})
				.catch((err) => {
					commit(USER_ERROR, err);
					reject(err);
				});
		});
	},
};

const mutations = {
	[AUTH_REQUEST]: (state) => {
		state.isLoading = true;
	},
	[AUTH_SUCCESS]: (state, { token, user, profile }) => {
		state.isLoading = false;
		if (user) state.currentUser = user;
		if (token) state.token = token;

		if (profile) state.currentUser.profiles = [...state.currentUser.profiles, profile];
	},
	[AUTH_ERROR]: (state, error) => {
		state.isLoading = false;
		if (error) {
			state.error = error;
			state.currentUser = null;
			state.token = '';
		}
	},
	[AUTH_LOGOUT]: (state) => {
		state.currentUser = null;
		state.token = null;
	},
	[USER_SUCCESS]: (state, { user, card }) => {
		state.isLoading = false;
		if (user) state.currentUser = user;
		if (card) state.card = card
	},
	[USER_ERROR]: (state, error) => {
		state.isLoading = false;
		if (error) {
			state.error = error;
		}
	},

};

export default {
	state,
	getters,
	actions,
	mutations
};
